import { useState } from "react";
import PropTypes from "prop-types";
import { Tabs, Tab } from "@mui/material";
import MDBox from "components/MDBox";
import { useICCCColors } from "../components/theme";
import PlacedDevicesPanel from "./PlacedDevicesPanel";
import UnplacedDevicesPanel from "./UnplacedDevicesPanel";

// Replaces the single Unplaced-only drawer with Placed/Unplaced tabs so an
// operator can verify placement without leaving Edit layout.
export default function DevicePanel({ placedDevices, unplacedDevices, onPlacedDeviceClick }) {
  const ICCC_COLORS = useICCCColors();
  const [tab, setTab] = useState(0);

  return (
    <MDBox
      sx={{
        bgcolor: ICCC_COLORS.cardBg,
        border: `1px solid ${ICCC_COLORS.cardBorder}`,
        borderRadius: 1.5,
        width: 240,
        maxHeight: 420,
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
        overflow: "hidden",
      }}
    >
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="fullWidth"
        sx={{
          minHeight: 40,
          borderBottom: `1px solid ${ICCC_COLORS.cardBorder}`,
          "& .MuiTab-root": {
            minHeight: 40,
            textTransform: "none",
            fontSize: 12,
            color: ICCC_COLORS.textSecondary,
          },
          "& .MuiTab-root.Mui-selected": { color: ICCC_COLORS.accent, fontWeight: 700 },
          "& .MuiTabs-indicator": { backgroundColor: ICCC_COLORS.accent },
        }}
      >
        <Tab label={`Placed (${placedDevices.length})`} />
        <Tab label={`Unplaced (${unplacedDevices.length})`} />
      </Tabs>
      <MDBox sx={{ p: 1.5, overflow: "auto", flex: 1 }}>
        {tab === 0 ? (
          <PlacedDevicesPanel devices={placedDevices} onDeviceClick={onPlacedDeviceClick} />
        ) : (
          <UnplacedDevicesPanel devices={unplacedDevices} />
        )}
      </MDBox>
    </MDBox>
  );
}

DevicePanel.propTypes = {
  placedDevices: PropTypes.arrayOf(PropTypes.object).isRequired,
  unplacedDevices: PropTypes.arrayOf(PropTypes.object).isRequired,
  onPlacedDeviceClick: PropTypes.func.isRequired,
};
